import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getOfferPhones = (state: IState) => {
  return pathOr([], ['offerData', 'offer', 'phones'], state);
};
